/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.simulation.environment.rpc.PortalService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import * as References from './PortalService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * @deprecated due to potential cache collision issues. Use from the .dfc.new.ts file instead.
 * This will also change the data structure from 'data.fieldName' to 'data.result'.
 *
 * Recomended usage: Use hooks from .hooks.ts file instead.
 *
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.simulation.environment.rpc.PortalService#createPortal
 */

export const CREATE_PORTAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: 'createPortal',
  args: ['exerciseId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * @deprecated due to potential cache collision issues. Use from the .dfc.new.ts file instead.
 * This will also change the data structure from 'data.fieldName' to 'data.result'.
 *
 * Recomended usage: Use hooks from .hooks.ts file instead.
 *
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.simulation.environment.rpc.PortalService#assignSinglePortal
 */

export const ASSIGN_SINGLE_PORTAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: 'assignSinglePortal',
  args: ['exerciseId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.assignSinglePortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});